


























































import { Component, Prop, Ref } from "vue-property-decorator";

import {
  DialogComponent,
  BaseDialog,
  DialogHeader,
  FormText,
  FormSelect
} from "sitewhere-ide-components";
import { VFlex, VTab, VTabItem, VLayout } from "vuetify/lib";
import DecoderConfiguration from "./decoders/DecoderConfiguration.vue";

import {
  IEventSourceGenericConfiguration,
  IEventDecoderGenericConfiguration
} from "sitewhere-configuration-model";

import { required, ValidationRule, helpers } from "vuelidate/lib/validators";

/** Validator for checking if id is already used */
const idConflict: ValidationRule = helpers.withParams(
  { type: "idConflict" },
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  (value: any, vm: any) => {
    const idsInUse: string[] = vm.idsInUse;
    let conflict = false;
    idsInUse.forEach(id => {
      if (vm.id == id) conflict = true;
    });
    return !conflict;
  }
);

@Component({
  components: {
    BaseDialog,
    DialogHeader,
    FormText,
    FormSelect,
    VFlex,
    VTab,
    VTabItem,
    VLayout,
    DecoderConfiguration
  },
  validations: {
    id: {
      required,
      idConflict
    }
  }
})
export default class EventSourceDialog extends DialogComponent<
  IEventSourceGenericConfiguration
> {
  @Prop() readonly tenantId!: string;
  @Prop() readonly type!: string;
  @Prop() readonly icon!: string;
  @Prop() readonly title!: string;
  @Prop() readonly width!: number;
  @Prop() readonly cancelLabel!: string;
  @Prop() readonly createLabel!: string;
  @Prop() readonly visible!: boolean;
  @Prop() readonly idsInUse!: string[];
  @Ref() readonly dialog!: BaseDialog;
  @Ref() readonly decoderConfiguration!: DecoderConfiguration;

  defaultDecoder = {
    type: "json",
    configuration: {}
  };

  id: string | null = null;
  decoder: IEventDecoderGenericConfiguration = this.defaultDecoder;

  /** Decoder type */
  get decoderType(): string | null {
    return this.decoder ? this.decoder.type : null;
  }

  /** Blank configuration if type updated */
  set decoderType(value: string | null) {
    if (value) {
      this.decoder = {
        type: value,
        configuration: {}
      };
    }
  }

  /** List of decoder types */
  decoderTypes: { text: string; value: string }[] = [
    {
      text: "JSON",
      value: "json"
    },
    {
      text: "Google Protocol Buffers",
      value: "protobuf"
    },
    {
      text: "Scripted Event Decoder",
      value: "scripted"
    }
  ];

  /** Save dialog fields */
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  save(): any {
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    const config: any = { id: this.id, type: this.type };
    this.decoder.configuration = this.decoderConfiguration.save();
    const decoder: { decoder: IEventDecoderGenericConfiguration } = {
      decoder: this.decoder
    };
    Object.assign(config, decoder);
    return config;
  }

  /** Reset the dialog */
  reset(): void {
    this.id = null;
    this.decoder = this.defaultDecoder;
    this.setActiveTab(0);
    if (this.decoderConfiguration) {
      this.decoderConfiguration.reset();
    }
    this.$v.$reset();
  }

  /** Validate fields */
  validate(): boolean {
    if (this.decoderConfiguration && !this.decoderConfiguration.validate()) {
      return false;
    }
    this.$v.$touch();
    return !this.$v.$invalid;
  }

  /** Load dialog from a given configuration */
  load(config: IEventSourceGenericConfiguration) {
    this.id = config.id;
    this.decoder = config.decoder;
  }

  /** Set the active tab */
  setActiveTab(tab: number): void {
    this.dialog.setActiveTab(tab);
  }

  /** Called after create button is clicked */
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  onCreateClicked(e: any) {
    this.$emit("createClicked", e);
  }

  /** Called after cancel button is clicked */
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  onCancelClicked(e: any) {
    this.$emit("cancelClicked", e);
  }
}
